<template>
  <el-container id="main" style="height: 100%; border: 1px solid #eee">
    <Aside />
    <el-container>
      <el-header style="text-align: left; font-size: 12px">
        <div id="header-logo">
          <img src="@/assets/header-logo.png" alt="Quotur Logo" />
        </div>
        <el-autocomplete
          clearable
          :fetch-suggestions="search"
          class="inline-input"
          v-model="state"
          placeholder="Search for Authors..."
          @select="handleSelect"
        ></el-autocomplete>

        <!-- <span style="display:flex;"></span> -->
        <!-- <img :src="user.picture" alt="Quotur Logo" /> -->
        <!-- <el-avatar :size="'medium'" :src="user.picture"></el-avatar> -->
      </el-header>
      <el-main>
        <!-- <Breadcrumbs /> -->
        <router-view />
      </el-main>
      <!-- <el-backtop target="#main .el-scrollbar__wrap" :bottom="100">
        <div
          style="{
        height: 100%;
        width: 100%;
        background-color: #f2f5f6;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa;
      }"
        >
          UP
        </div>
      </el-backtop> -->
    </el-container>
  </el-container>
</template>
<script>
import $HTTP from "./plugins/axios";
import nav from "./mixins/nav";
import Aside from "./components/Aside.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      authors: [],
      entries: [],
      author: null,
      isLoading: false,
      state: ""
    };
  },
  components: {
    Aside
  },

  computed: {
    ...mapGetters({
      user: "getUser"
    }),
    profileImage() {
      // console.log(this.$auth);
      if (this.$auth.profile) {
        return this.$auth.profile.picture;
      } else {
        return "";
      }
    }
  },
  mixins: [nav],
  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
      this.$auth.logout();
      this.$router.push({ path: "/" });
    },
    created() {
      this.getProlificAuthors();
    },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(author) {
      this.nav(author.id);
    },
    async getProlificAuthors() {
      this.authors = (await $HTTP.get(`/author/top`)).data.authors;
    },
    search(val, cb) {
      if (!val || val.length < 2) {
        return;
      }
      const request = {
        params: {
          query: val,
          limit: 20
        }
      };

      // this.$ga.event("author", "search", val, 1);
      $HTTP
        .get("/author/search", request)
        .then(res => res.data)
        .then(res => {
          this.entries = res.authors.map(x => {
            return {
              value: x.name,
              link: x.name,
              id: x.id
            };
          });
          cb(this.entries);
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  async created() {}
};
</script>

<style>
body,
html {
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}
.lg {
  font-size: 1.8rem;
}
#nav {
  padding: 30px;

  /* a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  } */
}

#main {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  /* // position: absolute;
  // top: 0;
  // left: 0;
  // bottom: 0; */
  color: #333;
  overflow: hidden;
}
.el-autocomplete-suggestion {
  transform-origin: center top;
  z-index: 2006;
  width: 100vw;
  position: absolute;
  top: 44px;
}

.el-autocomplete {
  top: -20px;
  left: 22px;
  width: 70vw;
}

@media only screen and (max-width: 530px) {
  .el-autocomplete {
    width: 60vw;
  }
}
#header-logo {
  display: inline;
}
@media only screen and (max-width: 490px) {
  .el-header {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  #header-logo {
    width: 40px;
    height: 55px;
  }
  .el-autocomplete {
    width: 55vw;
  }
}
</style>
